module.exports = __webpack_public_path__ + "img/friend-1.2efaa85a.png";